<template>
  <v-card :color="ui.cardColor" dark :max-width="ui.cardMaxWidth" :max-height="ui.cardMaxHeight">
    <v-card-title>
      <v-icon large left :color="ui.iconColor"> groups </v-icon>
      <span :class="ui.textHeadline"> Facility Users </span>
    </v-card-title>

    <v-card-text class="ml-2">
      <div :class="ui.textDescription">
        Facility active users, new acccess requests or apply restrictions.
      </div>
    </v-card-text>

    <v-card-actions>
      <v-list-tile class="grow">
        <v-spacer/>
        <GetAccessListPage :data="{tag: 'G1', tagd: 'F1', tags: 'U1', size: 'flat'}"
        v-if="this.licenceOK &&
        this.userOK &&
        this.enableAccessAuthDash('F1')
        "/>
        <v-btn :color="ui.colorWarning" flat dark
        v-if="this.getUser.pref.select.fauth === null">
          <v-icon left>
            info
          </v-icon>
          Select Facility
        </v-btn>
        <v-btn :color="ui.colorWarning" flat dark
        v-if="
        !this.licenceOK ||
        !this.userOK ||
        !this.enableAccessAuthDash('F1')"
        >
          <v-icon left>
            info
          </v-icon>
          Restricted Use
        </v-btn>
      </v-list-tile>
    </v-card-actions>
  </v-card>
</template>

<script>
import apptheme from "@/frame/theme/mixins/apptheme.js";
import licenceFunctions from "@/admin/functions/mixins/licenceFunctions.js";
import adminFunctions from "@/admin/functions/mixins/adminFunctions.js";
import GetAccessListPage from "@/support/access/components/GetAccessListPage";
import accessFunctions from "@/support/access/mixins/accessFunctions.js";
import { mapGetters } from "vuex";

export default {
  mixins: [apptheme, licenceFunctions, adminFunctions, accessFunctions],
  components: {
    GetAccessListPage
  },
  computed: {
    // eslint-disable-next-line
    ...mapGetters(["getUser"])
  },
  data() {
    return {
      valid: true
    };
  }
};
</script>
